<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100vw;height: 100vh;background-color: white;">
    <img src="/static/images/ylm/banner.png" style="width: 100vw;">
    <div style="width: 100vw;display: flex;">
      <div style="width: 50vw;text-align: right;">
        <img src="/static/images/ylm/logo.png" style="width: 25vw;margin-right: 3px;margin-top: 20px;">
      </div>
      <div style="width: 50vw;margin-left: 3px;margin-top: 14px;font-size: 18px;">防伪查询入口</div>
    </div>

    <div style="width: 100vw;display: flex;margin-top: 30px;">
      <div style="width: 50vw;display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <span>1、泰文防伪标签（旧）</span>
        <div style="width: 45vw;border-radius: 10px;border: 1px solid black;margin-top: 10px;text-align: center;">
          <img src="/static/images/ylm/tai1.png" style="width: 80%;margin-top: 10px;">
          <img src="/static/images/ylm/tai2.png" style="width: 80%;margin-top: 10px;margin-bottom: 10px;">
        </div>
        <div @click="oldAnti"
          style="width: 45vw;height:35px;margin-top: 15px;margin-bottom: 15px;border-radius: 5px;background-color: black;color: white;display: flex;justify-content: center;align-items: center;">
          查询入口</div>
      </div>
      <div style="width: 50vw;display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <span>2、中文防伪标签（新）</span>
        <div style="width: 45vw;border-radius: 10px;border: 1px solid black;margin-top: 10px;text-align: center;">
          <img src="/static/images/ylm/lv1.png" style="width: 80%;margin-top: 10px;">
          <img src="/static/images/ylm/zi1.png" style="width: 80%;margin-top: 10px;margin-bottom: 10px;">
        </div>
        <div @click="newAnti"
          style="width: 45vw;height:35px;margin-top: 15px;margin-bottom: 15px;border-radius: 5px;background-color: black;color: white;display: flex;justify-content: center;align-items: center;">
          查询入口</div>
      </div>
    </div>

  </div>
</template>



<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    oldAnti(){
      window.location.href = "http://business.yesno.com.cn/Sup8/page/ROYAL/index.aspx";
    },
    newAnti(){
      this.$router.replace({
        path: '/ylm.query'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/YouLeMei/Index.vue